import { useState } from "react";
import menuData from "../assets/menu/menu.json";
import styled from "styled-components";
import xlLogo from "../assets/images/xl-menu-logo.png";

window.localStorage.setItem('workingMenuData', JSON.stringify(menuData));

const PageSize = styled.div`
    width: 742px;
    padding: 1rem;
    box-sizing: border-box;
    background: white;
    font-family: serif;
    page-break-before: always;
    border: 1px solid gray;

    @media print {
        width: 100vw;
        border: none;
    }
`;

const PageBreak = styled.div`
    page-break-before: always;
    border-bottom: dashed 2px gray;

    @media print {
        border-bottom: none;
    }
`;

const Section = styled.div`
    width: 100%;
    display: inline-grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    margin-bottom: 40px;

    .fee {
        grid-column-start: 1;
        grid-column-end: 3;
        text-align: center;
        margin-top: 30px;
    }
`;

const FullSpan = styled.div`
    grid-column-start: 1;
    grid-column-end: 3;
`;

const SectionTitle = styled(FullSpan)`
    font-size: 30px;
    font-weight: bold;
    text-align: center;
`;

const ItemList = props => {
    const { category, hideLabel } = props;

    const ItemContainer = styled.div`
        display: flex;
        justify-content: space-between;
        font-size: 14px;

        div {
            line-height: 18px;
        }
    `;

    const LabelText = styled.div`
        font-size: 28px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 16px;
    `;

    if (!category) {
        return null;
    }

    return (
        <div>
            {!hideLabel && (
                <LabelText className="pdf-list-label">
                    {category.label}
                </LabelText>
            )}
            {category.items.map(i => {
                return (
                    <>
                        <ItemContainer className="pdf-item-name">
                            <div contenteditable="true">
                                {i.spicy && "* "}
                                {i.name}
                            </div>
                            <div contenteditable="true">{i.price}</div>
                        </ItemContainer>
                        {i.description && (
                            <span contenteditable="true" className="pdf-description">
                                {i.description}
                            </span>
                        )}
                    </>
                );
            })}
        </div>
    );
};

const Drinks = props => {
    const { menu } = props;
    const categories = Object.keys(menu);
    const {
        whiteGlass,
        redGlass,
        whiteBottle,
        redBottle,
        sparklingGlass,
        sparklingBottle,
        beer,
        tea,
        others
    } = menu;
    return (
        <>
            <PageSize>
                <Section>
                    <SectionTitle>Wine</SectionTitle>
                    <ItemList category={whiteGlass} />
                    <ItemList category={redGlass} />
                    <ItemList category={whiteBottle} />
                    <ItemList category={redBottle} />
                    <ItemList category={sparklingGlass} />
                    <ItemList category={sparklingBottle} />
                </Section>
                <Section>
                    <SectionTitle>Beverages</SectionTitle>
                    <FullSpan>
                        <ItemList category={beer} />
                    </FullSpan>
                    <ItemList category={tea} />
                    <ItemList category={others} />
                </Section>
                <Section>
                    <div className="fee">Corkage Fee 15</div>
                </Section>
            </PageSize>
        </>
    );
};

const Sepcials = props => {
    const SpecialsPageSize = styled(PageSize)`
        padding: 2rem 8rem;

        h1 {
            font-size: 36px;
            text-align: center;
        }

        div {
            font-size: 20px;
            margin-bottom: 4px;
            font-weight: bold;

            span {
                font-size: 17px;
                font-weight: normal;
                font-style: italic;
                display: block;
                margin-bottom: 20px;
                max-width: 80%;
            }
        }
    `;

    const { menu } = props;
    const { specials } = menu;

    return (
        <SpecialsPageSize>
            <h1>Specials</h1>
            <ItemList hideLabel category={specials} />
        </SpecialsPageSize>
    );
};

const Dinner = props => {
    const { menu } = props;
    const {
        appetizers,
        mushu,
        soup,
        veggie,
        poultry,
        beefLamb,
        pork,
        fish,
        seafood,
        noodle,
        rice
    } = menu;

    const DinnerPageSize = styled(PageSize)`
        .pdf-list-label {
            font-size: 26px;
        }

        .pdf-item-name {
            font-size: 16px;
            font-weight: bold;
        }

        .pdf-description {
            font-size: 13px;
            font-weight: normal;
            font-style: italic;
            margin-bottom: 8px;
            display: block;
        }

        .dinner-section {
            gap: 1rem;
        }

        .xl {
            width: 100%;
            height: 100px;
            text-align: center;
            margin-bottom: 30px;
            img {
                height: 100%;
            }
        }
    `;

    return (
        <DinnerPageSize>
            <div className="xl">
                <img src={xlLogo} />
            </div>
            <Section className="dinner-section">
                <ItemList category={appetizers} />
                <ItemList category={soup} />
                <ItemList category={veggie} />
                <ItemList category={beefLamb} />
                <ItemList category={poultry} />
                <FullSpan>
                    <PageBreak />
                </FullSpan>
                <ItemList category={seafood} />
                <div>
                    <ItemList category={mushu} />
                    <ItemList category={fish} />
                    <ItemList category={pork} />
                </div>
                <ItemList category={noodle} />
                <ItemList category={rice} />
            </Section>
        </DinnerPageSize>
    );
};

const MenuContainer = styled.div`
    width: 100vw;
    position: absolute;
    background: white;

    @media print {
        .select {
            display: none;
        }
    }
`;

const Menu = () => {
    const [view, setView] = useState("wine");
    return (
        <MenuContainer>
            <div className="select">
                <button onClick={() => setView("wine")}>wine</button>
                <button onClick={() => setView("specials")}>specials</button>
                <button onClick={() => setView("dinner")}>dinner</button>
            </div>
            {view === "wine" && <Drinks menu={menuData.drink} />}
            {view === "specials" && <Sepcials menu={menuData.dinner} />}
            {view === "dinner" && <Dinner menu={menuData.dinner} />}
        </MenuContainer>
    );
};

export default Menu;
